import { Injectable } from '@angular/core';

declare const cornerstoneTools: any;
declare const cornerstone: any;

interface Stack {
  imageIds: string[]
}

interface SynchronizerData {
  synchronizer: any,
  stack: Stack,
  elements: Element[]
}

@Injectable({
  providedIn: 'root'
})
export class ToolSynchronizerService {

  windowingSynchronizer: SynchronizerData;
  panZoomSynchronizer: SynchronizerData;

  constructor() {
    this.windowingSynchronizer = {
      elements: [],
      stack: {
        imageIds: []
      },
      synchronizer: new cornerstoneTools.Synchronizer(
        'cornerstoneimagerendered',
        cornerstoneTools.wwwcSynchronizer
      )
    };

    this.panZoomSynchronizer = {
      elements: [],
      stack: {
        imageIds: []
      },
      synchronizer: new cornerstoneTools.Synchronizer(
        'cornerstoneimagerendered',
        cornerstoneTools.panZoomSynchronizer
      )
    };
  }

  addToSynchronizer(stack: Stack, element: HTMLElement) {
    // Actualizamos el stack
    this.windowingSynchronizer.stack.imageIds.push(...stack.imageIds);
    this.panZoomSynchronizer.stack.imageIds.push(...stack.imageIds);
    this.windowingSynchronizer.elements.push(element);
    this.panZoomSynchronizer.elements.push(element);
    // Eliminamos duplicados
    this.windowingSynchronizer.elements = [...new Set(this.windowingSynchronizer.elements)];
    this.panZoomSynchronizer.elements = [...new Set(this.panZoomSynchronizer.elements)];
    this.windowingSynchronizer.stack.imageIds = [...new Set(this.windowingSynchronizer.stack.imageIds)];
    this.panZoomSynchronizer.stack.imageIds = [...new Set(this.panZoomSynchronizer.stack.imageIds)];


    // Añadimos el stack a los elementos y los elementos al synchronizer
    // y activamos la herramienta correspondiente con el Synchronizer
    this.windowingSynchronizer.elements.forEach(e => {
      this.windowingSynchronizer.synchronizer.add(e);
      cornerstoneTools.addStackStateManager(e, ['stack', 'Wwwc']);
      cornerstoneTools.addToolState(e, 'stack', this.windowingSynchronizer.stack);
    })
    this.panZoomSynchronizer.elements.forEach(e => {
      this.panZoomSynchronizer.synchronizer.add(e);
      cornerstoneTools.addStackStateManager(e, ['stack', 'Pan']);
      cornerstoneTools.addStackStateManager(e, ['stack', 'Zoom']);
      cornerstoneTools.addToolState(e, 'stack', this.panZoomSynchronizer.stack);
    })
  }

  // removeFromSynchronizer(stack: Stack, vp) {

  //   this.windowingSynchronizer.stack.imageIds.forEach(img => {
  //     let index = this.windowingSynchronizer.stack.imageIds.findIndex(el => el == img);
  //     if (index > -1)
  //       this.windowingSynchronizer.stack.imageIds.splice(index, 1);
  //   })
  //   this.panZoomSynchronizer.stack.imageIds.forEach(img => {
  //     let index = this.panZoomSynchronizer.stack.imageIds.findIndex(el => el == img);
  //     if (index > -1)
  //       this.panZoomSynchronizer.stack.imageIds.splice(index, 1);
  //   })

  //   if (vp.subElements && vp.subElements.length > 0) {
  //     vp.subElements.forEach(e => {
  //       let index = synch.elements.findIndex(el => el == e);
  //       if (index > -1) {
  //         synch.elements.splice(index, 1);
  //         synch.synchronizer.removeSource(e)
  //         synch.synchronizer.removeTarget(e)
  //       }
  //     })
  //   } else {
  //     let index = synch.elements.findIndex(el => el == vp.element);
  //     if (index > -1) {
  //       synch.elements.splice(index, 1);
  //       synch.synchronizer.removeSource(vp.element)
  //       synch.synchronizer.removeTarget(vp.element)
  //     }
  //   }

  // }

  getSynchronizerForTool(tool: string) {
    switch (tool) {
      case 'Wwwc':
        return this.windowingSynchronizer.synchronizer;
      case 'Pan':
        return this.panZoomSynchronizer.synchronizer;
      case 'Zoom':
        return this.panZoomSynchronizer.synchronizer;
      default:
        return null;
    }
  }

  // isViewportSynchronized(vp): string[] {
  //   let element;
  //   let tools: string[] = [];
  //   if (vp.subElements && vp.subElements.length > 0) {
  //     element = vp.subElements[0];
  //   } else {
  //     element = vp.element;
  //   }

  //   if (this.windowingSynchronizer.elements.findIndex(e => e == element) != -1)
  //     tools.push('Wwwc');
  //   if (this.panZoomSynchronizer.elements.findIndex(e => e == element) != -1)
  //     tools.push('PanZoom');
  //   return tools;
  // }

}